import React, {Component} from 'react'

import HeaderSearchComponent from './HeaderSearch.component'

class HeaderSearchContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: props.value || '',
      focus: false
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value === '') {
      this.setState({
        value: ''
      })
    }
  }

    handleChange = (evt) => {
      this.setState({
        value: evt.target.value
      })
    }

    handleClick = (evt) => {
      evt.preventDefault()

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Header Search',
        type: 'Datatable'
      })

      this.updateSearchValue(this.state.value)
    }

    handleEnter = (evt) => {
      if (evt.key === 'Enter') {
        this.updateSearchValue(this.state.value)

        this.props.analytics.propagateEvent({
          eventType: 'keydown',
          action: 'Header Search Enter',
          type: 'Datatable'
        })
      }
    }

    handleBlur = (evt) => {
      this.setState({
        focus: false
      })
    }

    handleFocus = (evt) => {
      this.setState({
        focus: true
      })
    }

    handleClear = (evt) => {
      evt.preventDefault()

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Header Search Clear',
        type: 'Datatable'
      })

      this.setState({
        value: ''
      })

      this.props.unsetSearch()
    }

    updateSearchValue(value) {
      if (value.trim() === '') {
        this.props.unsetSearch()
      } else {
        this.props.setSearch(value)
      }
    }

    render() {
      const events = {
        handleClick: this.handleClick,
        handleChange: this.handleChange,
        handleEnter: this.handleEnter,
        handleClear: this.handleClear,
        handleFocus: this.handleFocus,
        handleBlur: this.handleBlur
      }

      const {value, focus} = this.state
      const {i18n} = this.props

      return (
        <HeaderSearchComponent value={value} focus={focus} events={events} i18n={i18n} />
      )
    }
}

export default HeaderSearchContainer
